import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { SendOtpEmailInterstitial } from '../../components/SendOtpEmailInterstitial/SendOtpEmailInterstitial';
import { useAppSelector } from '../../stores/redux.store';
import { fetchPageState } from '../../utilities/fetch-api';
import { useNavigateSoftOrHard } from '../../utilities/hooks/useNavigateSoftOrHard';
import { usePageViewedEvent } from '../../utilities/analytics/analytics-web-client';
import { useEmailLinkRequest } from './useEmailLinkRequest';

const PAGE_ID = 'emailLinkInitiateOtpScreen';

export const emailLinkInitiateOtpLoader = ({ request }: { request: Request }) =>
  fetchPageState('/rest/email-link/verify-email/initiate-otp/state', request, {
    capabilities: ['capability-name--verify-email'],
  });

export default function EmailLinkInitiateOtpPage() {
  usePageViewedEvent(PAGE_ID);
  const email = useAppSelector(state => state.verifyEmailOtp.email);
  const [params] = useSearchParams();
  const navigate = useNavigateSoftOrHard();
  const { submit, isLoading, error } = useEmailLinkRequest(PAGE_ID);
  const token = params.get('token') || params.get('signature') || '';
  const errorCode =
    error === 'rate_limit_exceeded' ? 'link_rate_limited' : error ? 'unexpected_error' : undefined;

  const onSendVerificationEmail = async () => {
    const redirectTo = await submit(
      '/rest/email-link/verify-email/initiate-otp',
      { token },
      'redirectTo'
    );
    if (redirectTo) navigate(redirectTo);
  };

  return (
    <SendOtpEmailInterstitial
      pageId={PAGE_ID}
      email={email}
      isLoading={isLoading}
      errorCode={errorCode}
      onSendVerificationEmail={onSendVerificationEmail}
    />
  );
}
